import { useTranslation } from 'react-i18next';
import { TableRow, TableCell } from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';
import { useBillingReportDetails } from '../hooks/use-billing-data';
import { formatUTC } from './utils';
import { FeeBreakdownTable } from './FeeBreakdownTable';

interface ReportDetailsExpandedProps {
  reportId: string;
  report: any;
}

export function ReportDetailsExpanded({ reportId, report }: ReportDetailsExpandedProps) {
  const { t } = useTranslation('billing');
  const { reportDetails, isLoadingReportDetails } = useBillingReportDetails(reportId);

  return (
    <TableRow>
      <TableCell colSpan={9} className="p-0">
        <div className="bg-muted/30 border-t p-6">
          {isLoadingReportDetails ? (
            <div className="flex items-center justify-center py-8">
              <RefreshCw className="text-muted-foreground mr-2 h-6 w-6 animate-spin" />
              <span className="text-muted-foreground">{t('reportDetails.loadingBreakdown')}</span>
            </div>
          ) : reportDetails ? (
            <>
              <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
                <Card className="p-4">
                  <div className="text-muted-foreground text-sm">{t('reportDetails.invoiceNumber')}</div>
                  <div className="mt-1 text-lg font-semibold">
                    {reportDetails.invoice?.number || t('common.notAvailable')}
                  </div>
                </Card>
                <Card className="p-4">
                  <div className="text-muted-foreground text-sm">{t('reportDetails.totalVolume')}</div>
                  <div className="mt-1 text-lg font-semibold">
                    ${reportDetails.transactionSummary?.totalVolume || '0.00'}
                  </div>
                </Card>
                <Card className="p-4">
                  <div className="text-muted-foreground text-sm">{t('reportDetails.processingDate')}</div>
                  <div className="mt-1 text-lg font-semibold">
                    {formatUTC(report.periodEnd, 'MMM dd, yyyy')}
                  </div>
                </Card>
              </div>

              {reportDetails.breakdown && (
                <FeeBreakdownTable
                  breakdown={reportDetails.breakdown}
                  totalFees={report.totalFeesAmount || 0}
                />
              )}
            </>
          ) : null}
        </div>
      </TableCell>
    </TableRow>
  );
}
